const breadCrumb = "Lotação de Servidores - Manutenção de Informações Servidor";

const routes = [
  {
    path: "/cadastro-da-disponibilidade-de-servidores",
    name: "cadastro-da-disponibilidade-de-servidores",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/CadastroDaDisponibilidadeDeServidores/CadastroDaDisponibilidadeDeServidoresHome.vue"
      ),
  },
  {
    path: "/cadastro-da-disponibilidade-de-servidores/cadastro",
    name: "cadastro-da-disponibilidade-de-servidores-cadastro",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/CadastroDaDisponibilidadeDeServidores/CadastroDaDisponibilidadeDeServidoresCadastro.vue"
      ),
  },
  {
    path: "/cadastro-da-disponibilidade-de-servidores/:id/editar",
    name: "cadastro-da-disponibilidade-de-servidores-editar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/CadastroDaDisponibilidadeDeServidores/CadastroDaDisponibilidadeDeServidoresEditar.vue"
      ),
  },
  {
    path: "/cadastro-da-disponibilidade-de-servidores/:id/visualizar",
    name: "cadastro-da-disponibilidade-de-servidores-visualizar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/CadastroDaDisponibilidadeDeServidores/CadastroDaDisponibilidadeDeServidoresVisualizar.vue"
      ),
  },
  {
    path: "/cadastro-da-disponibilidade-de-servidores/:id/desistir",
    name: "cadastro-da-disponibilidade-de-servidores-desistir",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/CadastroDaDisponibilidadeDeServidores/CadastroDaDisponibilidadeDeServidoresDesistir.vue"
      ),
  },
];

export default routes;
